import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

//Nav
import CompanyJobsNav from "./CompanyJobsNav";
import CompanyJobsContent from "./CompanyJobsContent";

//DataTable
import { ViewCompanyProfile } from "../../../../Types/CompanyProfile/CompanyProfile";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const OpsStrucureCard = ({ companyInfo }: CompanyDataProps) => {
  const company_code = companyInfo?.code || "";
  const [basicTab, setBasicTab] = useState("1");

  return (
    <Card className="card-absolute">
      <CommonCardHeader
        headClass="bg-primary"
        tagClass="txt-light"
        title={"Job Titles"}
      />

      <CardBody>
        <CompanyJobsNav basicTab={basicTab} setBasicTab={setBasicTab} />
        <CompanyJobsContent tabId={basicTab} companyInfo={companyInfo} />
      </CardBody>
    </Card>
  );
};

export default OpsStrucureCard;
